import { Fragment } from "react";

const STEPS = [
    "Settings",
    "Apps",
    "Remote Desktop Commander",
    "Connected accounts",
];

/**
 * Where ChatGPT shows which Desktop Commander account it uses. Wraps only between steps, never
 * inside one, so "Remote Desktop Commander" is not split across lines.
 */
export default function ChatGptAccountsPath() {
    return (
        <>
            {STEPS.map((step, index) => (
                <Fragment key={step}>
                    {index > 0 && " › "}
                    <span
                        style={{
                            whiteSpace: "nowrap",
                        }}
                    >
                        {step}
                    </span>
                </Fragment>
            ))}
        </>
    );
}
